export class MmdDataDeserializer {
    isDeviceLittleEndian;
    _dataView;
    _decoder;
    _offset;
    constructor(arrayBuffer) {
        this.isDeviceLittleEndian = this._getIsDeviceLittleEndian();
        this._dataView = new DataView(arrayBuffer);
        this._decoder = null;
        this._offset = 0;
    }
    get offset() {
        return this._offset;
    }
    set offset(value) {
        this._offset = value;
    }
    _getIsDeviceLittleEndian() {
        const array = new Int16Array([256]);
        return new Int8Array(array.buffer)[1] === 1;
    }
    swap16Array(array) {
        for (let i = 0; i < array.length; ++i) {
            const value = array[i];
            array[i] = ((value & 0xFF) << 8) | ((value >> 8) & 0xFF);
        }
    }
    swap32Array(array) {
        for (let i = 0; i < array.length; ++i) {
            const value = array[i];
            array[i] = ((value & 0xFF) << 24) | ((value & 0xFF00) << 8) | ((value >> 8) & 0xFF00) | ((value >> 24) & 0xFF);
        }
    }
    getUint8() {
        const value = this._dataView.getUint8(this._offset);
        this._offset += 1;
        return value;
    }
    getInt8() {
        const value = this._dataView.getInt8(this._offset);
        this._offset += 1;
        return value;
    }
    getUint8Array(dest) {
        const source = new Uint8Array(this._dataView.buffer, this._offset, dest.byteLength);
        dest.set(source);
        this._offset += dest.byteLength;
    }
    getUint16() {
        const value = this._dataView.getUint16(this._offset, true);
        this._offset += 2;
        return value;
    }
    getUint16Array(dest) {
        const source = new Uint8Array(this._dataView.buffer, this._offset, dest.byteLength);
        new Uint8Array(dest.buffer, dest.byteOffset, dest.byteLength).set(source);
        this._offset += dest.byteLength;
        if (!this.isDeviceLittleEndian)
            this.swap16Array(dest);
    }
    getInt16() {
        const value = this._dataView.getInt16(this._offset, true);
        this._offset += 2;
        return value;
    }
    getUint32() {
        const value = this._dataView.getUint32(this._offset, true);
        this._offset += 4;
        return value;
    }
    getUint32Array(dest) {
        const source = new Uint8Array(this._dataView.buffer, this._offset, dest.byteLength);
        new Uint8Array(dest.buffer, dest.byteOffset, dest.byteLength).set(source);
        this._offset += dest.byteLength;
        if (!this.isDeviceLittleEndian)
            this.swap32Array(dest);
    }
    getInt32() {
        const value = this._dataView.getInt32(this._offset, true);
        this._offset += 4;
        return value;
    }
    getInt32Array(dest) {
        const source = new Uint8Array(this._dataView.buffer, this._offset, dest.byteLength);
        new Uint8Array(dest.buffer, dest.byteOffset, dest.byteLength).set(source);
        this._offset += dest.byteLength;
        if (!this.isDeviceLittleEndian)
            this.swap32Array(dest);
    }
    getFloat32() {
        const value = this._dataView.getFloat32(this._offset, true);
        this._offset += 4;
        return value;
    }
    getFloat32Array(dest) {
        const source = new Uint8Array(this._dataView.buffer, this._offset, dest.byteLength);
        new Uint8Array(dest.buffer, dest.byteOffset, dest.byteLength).set(source);
        this._offset += dest.byteLength;
        if (!this.isDeviceLittleEndian)
            this.swap32Array(dest);
    }
    getFloat32Tuple(length) {
        const result = new Array(length);
        for (let i = 0; i < length; ++i) {
            result[i] = this._dataView.getFloat32(this._offset, true);
            this._offset += 4;
        }
        return result;
    }
    initializeTextDecoder(encoding) {
        this._decoder = new TextDecoder(encoding);
    }
    getDecoderString(length, trim) {
        if (this._decoder === null) {
            throw new Error("TextDecoder is not initialized.");
        }
        let bytes = new Uint8Array(this._dataView.buffer, this._offset, length);
        this._offset += length;
        if (trim) {
            for (let i = 0; i < bytes.length; ++i) {
                if (bytes[i] === 0) {
                    bytes = bytes.subarray(0, i);
                    break;
                }
            }
        }
        return this._decoder.decode(bytes);
    }
    getSignatureString(length) {
        const decoder = new TextDecoder("utf-8");
        const bytes = new Uint8Array(this._dataView.buffer, this._offset, length);
        this._offset += length;
        return decoder.decode(bytes);
    }
    getPaddedArrayOffset(elementSize, length) {
        this._offset += this._offset % elementSize === 0 ? 0 : elementSize - this._offset % elementSize;
        const offset = this._offset;
        this._offset += elementSize * length;
        return offset;
    }
    get bytesAvailable() {
        return this._dataView.byteLength - this._offset;
    }
}
